// features/products/services/useFetchClientsByProduct.ts
import { useQuery } from '@tanstack/react-query'
import api from '@/lib/api'
import { useAccessToken } from '@/features/auth/state/auth'

export function useFetchClientsByProduct(id_user?: string, id_tenant?: string, opts?: { enabled?: boolean }) {
  const token = useAccessToken()

  return useQuery({
    // inclua os parâmetros na queryKey pra cache correto
    queryKey: ['productClientsUsers', id_user, id_tenant],
    enabled: Boolean(token && id_user && id_tenant && (opts?.enabled ?? true)),
    queryFn: async () => {
      const resp = await api.get(`/products/filter/${id_user}/${id_tenant}`, {
        headers: { Authorization: `Bearer ${token}` }
      })
      const payload = resp?.data?.data
      // 🔒 Normalização: sempre array
      if (Array.isArray(payload)) return payload
      if (payload == null) return [] as any[]
      return [payload]
    }
  })
}
